import Axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import router from '@/router'
import {
  getToken,
  getMark
} from '@/utils/auth'

const BASE_URL = process.env.VUE_APP_BASE_API
const request = Axios.create({
  baseURL: BASE_URL,
  timeout: 5 * 60 * 1000
})
request.interceptors.request.use(
  (config) => {
    // do something before request is sent
    if (store.getters.token) {
      config.headers.token = getToken()
    } else {
      router.push('/login')
    }
    if (store.getters.mark) {
      config.headers.mark = getMark()
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
request.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    if (response.status === 403) {
      // to re-login
      MessageBox.confirm(
        '登录超时, 您可以停留在此页面，或重新登录',
        '确认登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          store.dispatch('user/resetToken').then(() => {
            window.location.reload()
          })
        })
    }
    // upms模块接口返回
    if (res.code === 0 || res.state === 'success') {
      return res
    }
    if (res.state === 'error') {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }
    if (res.ResultCode === 400 || res.ResultCode === 408) {
      Message({
        message: res.ResultDesc || 'Error',
        type: 'warning',
        duration: 5 * 1000
      })
    }
    // if the custom code is not 200, it is judged as an error.
    if (res.ResultCode === 200) {
      if (res.RecordCount) {
        return {
          total: res.RecordCount,
          list: res.Data_Obj
        }
      }
      return res
    } else {
      // Message({
      //   message: res.ResultDesc || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000,
      // });
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // return Promise.reject(new Error(res.ResultDesc || 'Error'))
      return res
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
request.get = (url, params = {}) => {
  return request({
    method: 'GET',
    url: url,
    params: params
  })
}
request.post = (url, params = {}) => {
  return request({
    method: 'POST',
    url: url,
    data: params
  })
}
request.pictureStream = (url, params) => {
  return request({
    method: 'GET',
    url: url,
    params: params,
    responseType: 'arraybuffer'
  })
}
request.exportData = (url, params) => {
  return request({
    method: 'POST',
    url: url,
    data: params,
    responseType: 'blob'
  })
}
request.exportDataGet = (url, params) => {
  return request({
    method: 'GET',
    url: url,
    params: params,
    responseType: 'blob'
  })
}
export {
  BASE_URL,
  request
}
